import z from 'zod';

import { SectionDtoScheme } from '~modules/section/model';

export const SectionWithPeriodDtoScheme = SectionDtoScheme.extend({
	period: z.number().describe('Период табелирования').nullable().optional(),
	advance_locked: z.boolean().optional(),
	salary_locked: z.boolean().optional(),
});

export type SectionWithPeriodDto = z.infer<typeof SectionWithPeriodDtoScheme>;

export const PeriodBySectionDtoScheme = z.object({
	section_id: z.number().describe('Идентификатор секции'),
	period: z.number().describe('Значение периода табелировани в сутках').nullable(),
});

export type PeriodBySectionDto = z.infer<typeof PeriodBySectionDtoScheme>;

export const PeriodLockDtoScheme = z.object({
	section_id: z.number(),
	year: z.number(),
	month: z.number(),
	advance_locked: z.boolean(),
	salary_locked: z.boolean(),
});

export type PeriodLockDto = z.infer<typeof PeriodLockDtoScheme>;

export type LockType = 'advance' | 'salary';
